const SUCCESS_STATUS = 200;

const successfulResponse = (axiosResult) => {
    const {status, data} = axiosResult;
    if (status !== SUCCESS_STATUS) {
        return false;
    }

    // Check if data is object for success
    if (data === Object(data)) {
        if (typeof data.success !== 'undefined') {
            return data.success;
        }
    }

    // todo if data is string it may be a dump from the API

    return true;
}

export { successfulResponse }